import { Component, OnInit } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { Router } from '@angular/router';
import { ApiService } from '../common/API/api.service';
import { NotifierService } from 'angular-notifier';
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BackRestrict } from '../common/backRestrict'
import { NgxSpinnerService } from 'ngx-spinner';
import { isNullOrUndefined } from 'util';
import { DeviceCategory } from '../Models/DeviceData';


declare var config;

@Component({
  selector: 'app-celldetestgroup',
  templateUrl: './celldetestgroup.component.html',
  styleUrls: ['./celldetestgroup.component.css']
})
export class CelldetestgroupComponent {
  public Enterprisedata = [];
  public form: FormGroup;
  public EnterpriseID: any;
  private NotAddedTestList = [];
  private GroupTestList = [];
  private ManageList = [];
  private EnterprisePartnerID;
  EditClick: boolean;
  IsDisplayQuality:boolean
  private UnusedTestListOrg = [];
  savebtn: any;
  GdData: boolean;
  private readonly notifier: NotifierService;
  Enterpriselist: any;
  EnterprisePartnerlist: any;
  modfyEnterprisePartnerList: any;
  showUL: boolean;
  AddGroupInfo: boolean;
  disabledSubmitBtn: boolean;
  deductionArray = [];
  deductionVal: any;
  myModal: boolean;
  DeductionInput: boolean;
  DeviceCategory: any;
  DeviceCategoryID: any;
  deviceCategoryType: any;
  DeviceCategoryTypeID: any;
  CameraID: any;
  // SubscriberList: any;
  constructor(
    private router: Router, private backrestrict: BackRestrict, private _apiService: ApiService, private formbuilder: FormBuilder,

    private apiUrl: apiUrlComponent, notifierService: NotifierService, private spinner: NgxSpinnerService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.deviceCategoryType = config.CameraDeviceType;
    this.DeviceCategoryTypeID = 0;
    this.CameraID = config.CameraID;
    this.DeviceCategoryID = config.DeviceCategoryID;
    this.EnterpriseID = config.EnterpriseID;
    this.backrestrict.clearBrowserBackHistory();
    this.getEnterprise_EnterprisePartner();
    this.GetDeviceCategory();
    this.GdData = true;
    this.savebtn = false;
    this.disabledSubmitBtn = true;

  }
  getEnterprise_EnterprisePartner() {
    debugger
    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/get-store').subscribe(result => {
      if (result.IsSuccess) {
        this.Enterpriselist = (result.Data.Table1.filter(X => X.IsActive !== false));
        this.EnterprisePartnerlist = (result.Data.Table2.filter(X => X.IsActive !== false));

        // for (let i = 0; i < 3; i++) {
        //   let filterResult: any = result.Data[i].filter(u => u.EnterpriseID == this.EnterpriseID);

        //   console.log(JSON.stringify(filterResult));
        //   this.Enterprisedata=filterResult;
        // }

        this.Enterprisedata = result.Data.Table2.filter(X => X.EnterpriseID == this.EnterpriseID);
        // this.SubscriberList = result.Data.Table3;
        this.spinner.hide();
      }
    },
      error => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }

  GetDeviceCategory() {
    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/GetDeviceCategory').subscribe(result => {
      this.spinner.hide();
      this.DeviceCategory = result;
    },
      error => {
        console.log(error);
      }
    );
  }

  onChangeEnterprise(event) {
    this.showUL = false;
    var EnterpriseID = event;
    this.modfyEnterprisePartnerList = this.EnterprisePartnerlist.filter((item) => item.EnterpriseID == EnterpriseID);
  }
  onChangeEnterprisePartner(event) {
    debugger;
    this.showUL = false;
    this.EnterprisePartnerID = event;
    if (event != '0' && this.DeviceCategoryID != '0')
      this.getTestGrouping();
    else
      this.disabledSubmitBtn = true;
  }
  OnChangeDeviceCategory(event) {
    debugger;
    this.showUL = false;
    this.EnterprisePartnerID = this.EnterprisePartnerID ? this.EnterprisePartnerID : '0';
    if (event != '0' && this.EnterprisePartnerID != '0' && event != this.CameraID) {
      this.DeviceCategoryTypeID = 0;
      this.getTestGrouping();
    }
    else
      this.disabledSubmitBtn = true;
  }

  getTestGrouping() {
    debugger;
    this.spinner.show();
    var SubscriberProductID = this.Enterprisedata.filter(x => x.EnterprisePartnerID == this.EnterprisePartnerID)[0].SubscriberProductID;
    var Addbody = {
      EnterprisePartnerID: this.EnterprisePartnerID,
      SubscriberProductID: SubscriberProductID,
      IsDisplayQuality :true
    }
    //this._apiService.post(config.WebApiPath + 'api/getCellDeGrouping/', Addbody).subscribe(result => {
    this._apiService.post(config.WebApiPath + 'api/support-tool/cellde-testgroup/', Addbody).subscribe(result => {
      debugger;
      if (result !== null) {
        var cellDeData = [];
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.showUL = true;
        debugger;
        this.UnusedTestListOrg = [];



        //this.UnusedTestListOrg=result.Data.mCheckTestGroup;
        this.UnusedTestListOrg = JSON.parse(result.Data.mCheckTestGroup).Data;
        // this.UnusedTestListOrg = JSON.parse(result.Data.CelldeTestGroup);

        // if (result.Data.mCheckTestGroup != null || result.Data.mCheckTestGroup != undefined) {
        //   this.NotAddedTestList = JSON.parse(result.Data.mCheckTestGroup).Data.Table2;
        // }
        // else {
        //   this.NotAddedTestList = JSON.parse(result.Data.mCheckTestGroup);
        // }

        var mCheckList = JSON.parse(result.Data.mCheckTestGroup).Data.Table.filter(x => ((x.DiagnosticTypeID == 2 ||
          x.DiagnosticTypeID == 3 || x.DiagnosticTypeID == 4)));
        mCheckList.forEach(x => {
          this.NotAddedTestList.push({
            TestID: x.TestID,
            Test: x.TestName
          })
        })
        debugger
        this.NotAddedTestList = this.NotAddedTestList.filter(x => x.TestID !== null && x.Test !== null);

        result.Data.CelldeTestGroup.CelldeTestGroup.Table.filter(x => x.DeviceCategoryID == this.DeviceCategoryID && x.DeviceCategoryType
          == this.DeviceCategoryTypeID).forEach(X => {
            let testdata: any = [];
            let testName = '';
            let TestID = null;
            if (X.TestID !== null) {
              testdata = this.NotAddedTestList.find(Y => Y.TestID === X.TestID);
              if (!isNullOrUndefined(testdata)) {
                testName = testdata.Test;
                TestID = testdata.TestID;
                this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.TestID === X.TestID)), 1);
              }
            }
            cellDeData.push(
              {
                TestID: TestID,
                Test: testName,
                ParentID: X.ParentID,
                ParentTest: X.ParentTest,
                Deduction: X.Deduction,
                bgClass: X.bgClass,
                DeviceCategoryID: this.DeviceCategoryID
              })


          })

        let GroupTest = this.uniqueGroup(cellDeData, function (x) { return x.ParentTest; });
        if (GroupTest.length > 0) {
          GroupTest.forEach(element => {
            let TestList = cellDeData.filter(x => x.ParentTest === element);
            var Index = TestList.findIndex(x => x.TestID === null);
            if (Index >= 0) {
              TestList.push(
                {
                  DeviceCategoryID: this.DeviceCategoryID,
                  ParentTest: TestList[Index].ParentTest,
                  ParentID: TestList[Index].ParentID,
                  Deduction: TestList[Index].Deduction,
                  Test: TestList[Index].Test,
                  TestID: TestList[Index].TestID,
                  bgClass: 'd-none',
                  Class: 'd-none'
                }

              )
              TestList.splice(Index, 1);
            }


            this.GroupTestList.push(
              {
                DeviceCategoryID: this.DeviceCategoryID,
                ParentTest: element,
                ParentID: TestList[0].ParentID,
                Deduction: TestList[0].Deduction,
                ChilTestData: TestList,
                bgClass: ''
              }
            )
          });
        }
      }
      this.spinner.hide();
    },
      error => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }

  showchildtest(id: any, tabId: any) {
    debugger;
    $('#child_' + id).slideToggle(200);
    $('#iconAngle' + tabId).toggleClass('fa-angle-up fa-angle-down');
  }

  manageGroups() {
    debugger;
    this.spinner.show();
    this.deductionArray = [];
    this.disabledSubmitBtn = true;
    this.ManageList = [];
    this.GroupTestList.forEach(element => {
      if (element.ChilTestData.length > 0) {
        element.ChilTestData.forEach(Childelement => {
          //if (element.ChilTestData.length > 0) {
          this.ManageList.splice(0, 0,
            {
              ParentTest: element.ParentTest,
              ParentID: element.ParentID,
              TestID: Childelement.TestID,
              Deduction: element.Deduction,
              EnterprisePartnerID: parseInt(this.EnterprisePartnerID),
              DeviceCategoryID: this.DeviceCategoryID,
              DeviceCategoryType: this.DeviceCategoryTypeID
            }
          )
          //}
          // else {
          //   this.ManageList.splice(0, 0,
          //     {
          //       ParentTest: element.ParentTest,
          //       ParentID: element.ParentID,
          //       TestID: null,
          //       Deduction: element.Deduction,
          //       EnterprisePartnerID: parseInt(this.EnterprisePartnerID),
          //     }
          //   )
          // }
        });
      } else {
        this.ManageList.splice(0, 0,
          {
            ParentTest: element.ParentTest,
            ParentID: element.ParentID,
            TestID: null,
            Deduction: element.Deduction,
            EnterprisePartnerID: parseInt(this.EnterprisePartnerID),
            DeviceCategoryID: this.DeviceCategoryID,
            DeviceCategoryType: this.DeviceCategoryTypeID
          }
        )

      }
    });


    debugger;

    this.NotAddedTestList = this.NotAddedTestList.map(o => { return { Test: o.Test, TestID: o.TestID }; });
    this.ManageList = this.ManageList.filter(x => x.ParentTest !== null && x.ParentID !== null
      && x.Deduction !== null && x.EnterprisePartnerID !== null);

    if (this.ManageList.length < 1) {
      this.ManageList.push({
        ParentTest: null,
        ParentID: null,
        TestID: null,
        Deduction: null,
        EnterprisePartnerID: parseInt(this.EnterprisePartnerID),
      })
    }
    if (this.NotAddedTestList.length < 1) {
      this.NotAddedTestList.push({
        Test: 0,
        TestID: 0
      })
    }

    var Parameters = {
      ManageList: this.ManageList,
      NotAddedTestList: this.NotAddedTestList

    }

    this._apiService.post(config.WebApiPath + 'api/updateCellDeGroups/', Parameters).subscribe(result => {
      this.spinner.hide();

      if (result.IsSuccess === true) {
        debugger;
        this.notifier.notify('success', 'Data Updated Successfully');
        this.getTestGrouping();
        this.ManageList = [];
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.ManageList = [];
        this.GdData = true;
        this.EditClick = false;
        //this.editbtn = true;
        this.savebtn = false;

      }
      else {
        this.notifier.notify('error', 'An Error Occured');
        this.getTestGrouping();
        this.ManageList = [];
        this.ManageList = [];
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.ManageList = [];
        this.GdData = true;
        this.EditClick = false;
        // this.editbtn = true;
        this.savebtn = false;

      }
    },
      error => {
        console.log(error);
      }
    );


  }


  onItemDrop(e: any) {
    debugger;

    const ParentID = parseInt(e.nativeEvent.currentTarget.id);
    const GroupTest = this.GroupTestList.find(x => x.ParentID === ParentID);
    if ((this.NotAddedTestList.filter(x => x.TestID === e.dragData.TestID).length) !== 0) {
      this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.TestID === e.dragData.TestID)), 1);
      //this.isdisabledSubmitBtn();
      this.disabledSubmitBtn = false;
    }
    else {
      if (e.dragData.ParentID === null) {
        this.GroupTestList.forEach(X => {
          if (X.ChilTestData.find(X => X.TestID == e.dragData.TestID)) {
            X.ChilTestData.splice(X.ChilTestData.indexOf(X.ChilTestData.find(row => row.TestID === e.dragData.TestID)), 1);
          }
        })
        // this.isdisabledSubmitBtn();
        this.disabledSubmitBtn = false;
      }
    }
    if ((GroupTest.ChilTestData.filter(x => x.TestID === e.dragData.TestID).length) === 0) {
      if (e.dragData.ParentID === null || e.dragData.ParentID === undefined) {
        GroupTest.ChilTestData.splice(0, 0, {
          ParentID: ParentID,
          TestID: e.dragData.TestID,
          Test: e.dragData.Test,
          bgClass: 'new-added-child '
        });
        //this.isdisabledSubmitBtn();
        this.disabledSubmitBtn = false;
      }
    }





  }

  onItemremove(item: any) {
    debugger
    if (this.NotAddedTestList.length > 0) {
      if ((this.NotAddedTestList.filter(x => x.TestID === item.TestID).length) === 0) {
        this.NotAddedTestList.splice(0, 0, {
          TestID: item.TestID,
          Test: item.Test,
          PercentageDeduction: item.PercentageDeduction,
          bgClass: 'new-added-child'
        });
        //this.isdisabledSubmitBtn();
        this.disabledSubmitBtn = false;
      }

    }
    else if (this.NotAddedTestList.length === 0) {
      item.bgClass = 'new-added-child';
      this.NotAddedTestList.splice(0, 0, item);
      this.isdisabledSubmitBtn();
    }

    const dragTestData = this.GroupTestList.find(x => x.ParentID === item.ParentID);
    const childTestData = this.GroupTestList.find(x => x.ParentID === item.ParentID).ChilTestData;
    dragTestData.ChilTestData = childTestData.filter(x => x.TestID !== item.TestID);
  }
  onDropTestGroup(e: any) {
    debugger;

    this.isdisabledSubmitBtn();
    const GroupTest = this.GroupTestList.find(x => x.ParentID === e.TestID);
    this.GroupTestList.splice(0, 0, {
      ParentTest: e.dragData.Test,
      ParentID: e.dragData.TestID,
      Deduction: 0,
      ChilTestData: [],
      bgClass: 'new-added-group'
    });
    if (this.NotAddedTestList.find(X => X.TestID == e.dragData.TestID)) {
      this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.TestID === e.dragData.TestID)), 1);
    }
    // else{
    //   this.notifier.notify('warning', 'Not able to drag child to Direct Parent , first of all add in child Tests ');
    // }

    else {
      this.GroupTestList.forEach(X => {
        if (X.ChilTestData.find(X => X.TestID == e.dragData.TestID)) {
          X.ChilTestData.splice(X.ChilTestData.indexOf(X.ChilTestData.find(row => row.TestID === e.dragData.TestID)), 1);
        }
      })


    }
  }
  Reset() {
    this.disabledSubmitBtn = true;
    this.savebtn = false;
    this.deductionArray = [];
    this.getTestGrouping();
    this.notifier.notify('success', 'Reset Successfully');
  }

  editDeduction(Id: any, parentID = null) {
    debugger;
    this.showEditTextToggle(Id);
    //this.disabledSubmitBtn = true;

    if (this.deductionArray.length > 0) {
      for (var i = 0; this.GroupTestList.length > i; i++) {
        if ((this.deductionArray.find(X => X.ParentID === this.GroupTestList[i].ParentID)) === null) {
          this.deductionArray.splice(0, 0, {
            Deduction: parseInt($('#DeductionTB' + i).val()),
            UpdatedDeduction: parseInt($('#DeductionTB' + i).val()),
            ID: i,
            ParentID: this.GroupTestList[i].ParentID
          })
        }
      }

    }
    else {
      for (var i = 0; this.GroupTestList.length > i; i++) {
        this.deductionArray.push({
          Deduction: parseInt($('#DeductionTB' + i).val()),
          UpdatedDeduction: parseInt($('#DeductionTB' + i).val()),
          ID: i,
          ParentID: this.GroupTestList[i].ParentID
        })
      }
    }
    // this.savechanges(Id, parentID);



  }

  showEditTextToggle(Id: any) {
    $('#btnsave' + Id).toggleClass('d-inline-block');
    $('#btnEdit' + Id).toggleClass('d-none');
    $('#iconUndo' + Id).toggleClass('d-inline-block');
    $('#DeductionLB' + Id).toggleClass('d-none');
    $('#DeductionTB' + Id).toggleClass("d-inline-block");
  }
  undoDeduction(Id: any, ParentID: any) {
    this.savebtn = false;
    this.showEditTextToggle(Id);
    debugger;
    let deduction = this.deductionArray.find(x => x.ParentID == ParentID);
    $('#DeductionTB' + Id).val(deduction.Deduction)
    $('#DeductionLB' + Id).text('Deduction : ' + deduction.Deduction + '%')
    this.GroupTestList.filter(x => {
      if (x.ParentID == ParentID) {
        x.Deduction = parseInt(deduction.Deduction);
        x.bgClass = '';
      }
    })
    this.deductionArray.filter(x => {
      if (x.ParentID == ParentID) {
        x.UpdatedDeduction = parseInt(deduction.Deduction);
      }
    })
    // if (this.GroupTestList.filter(X => X.bgClass === '').length === this.GroupTestList.length) {
    //   this.disabledSubmitBtn = true;
    // }

  }

  savechanges(Id: any, parentID) {
    var deductionval = parseInt($('#DeductionTB' + Id).val());
    if (deductionval <= 100 && deductionval >= 0) {
      this.showEditTextToggle(Id);
      debugger;
      if (this.deductionArray[Id].UpdatedDeduction !== parseInt($('#DeductionTB' + Id).val())) {
        this.GroupTestList[Id].Deduction = parseInt($('#DeductionTB' + Id).val());
        this.deductionArray[Id].UpdatedDeduction = parseInt($('#DeductionTB' + Id).val());
        this.GroupTestList[Id].bgClass = 'new-added-group'
        this.isdisabledSubmitBtn();
        let deduction = this.deductionArray.find(x => x.ParentID === parentID);
        $('#DeductionTB' + Id).val(deduction.UpdatedDeduction)
        $('#DeductionLB' + Id).text('Deduction : ' + deduction.UpdatedDeduction + '%')
      }
      if (this.deductionArray[Id].Deduction === parseInt($('#DeductionTB' + Id).val())) {
        this.GroupTestList[Id].bgClass = '';
      }

    }
    else {

      $('#validationModel').click();
      $('#DeductionTB' + Id).val('')
    }

  }

  isdisabledSubmitBtn() {
    var count = 0;
    for (var i = 0; this.GroupTestList.length > i; i++) {
      if ($('#DeductionTB' + i).attr('class') !== 'form-control d-none d-inline-block') {
        count++
      }
    }
    if (count === this.GroupTestList.length) {
      this.disabledSubmitBtn = false;
    }
    else {
      this.disabledSubmitBtn = true;
    }
  }

  DeleteGroup(Id: any) {
    debugger;
    this.isdisabledSubmitBtn();
    var newList = []
    newList = this.GroupTestList.filter(x => x.ParentID === Id);
    newList.forEach(Y => {
      Y.ChilTestData.forEach(X => {
        if (X.TestID != null) {
          this.NotAddedTestList.splice(0, 0, {
            TestID: X.TestID,
            Test: X.Test,
            PercentageDeduction: null,
            bgClass: 'new-added-group'
          });
        }

      })
      this.NotAddedTestList.splice(0, 0, {
        TestID: Y.ParentID,
        Test: Y.ParentTest,
        PercentageDeduction: null,
        bgClass: 'new-added-group'
      });
    })
    this.GroupTestList.splice(this.GroupTestList.indexOf(this.GroupTestList.find(row => row.ParentID === Id)), 1);

  }


  uniqueGroup(arr, fn) {
    var unique = {};
    var distinct = [];
    arr.forEach(function (x) {
      var key = fn(x);
      if (!unique[key]) {
        distinct.push(key);
        unique[key] = true;
      }
    });
    return distinct;
  }

  keyPressNumbers(event: any) {
    debugger;
    const pattern = /^[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  OnChangeDeviceCategoryType() {
    this.getTestGrouping();
  }
}